import React, { useState, useEffect } from "react";
import { Link, useHistory } from "react-router-dom";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Breadcrumb,
  Tooltip,
  OverlayTrigger,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";
import { Rating } from "react-simple-star-rating";

import CustomNavbar from "../../components/CustomNavbar";
import CustomTable from "../../components/CustomTable";
import CustomPagint from "../../components/CustomPagint";

import messages from "../../redux/messages";
import SidebarDashboard from "../../components/SidebarDashboard";
import {
  deleteRequestTracking,
  editRequestTracking,
  getRequestTracking,
  saveRequestTracking,
  sendMailForCandidates,
} from "../../redux/seleccionContratacion/RequestTracking/actions";
import {
  editRequirementsMonitorById,
  getRequirementsMonitorById,
} from "../../redux/seleccionContratacion/RequirementsMonitor/actions";
import { getEstados } from "../../redux/seleccionContratacion/estados/actions";
import { getFuncFormations } from "../../redux/func_formacion/actions";
import { getTitles } from "../../redux/descriptorsProfiles/Titles/actions";
import config from "../../config";

const RequestTracking = (props) => {
  // const filters = [
  //   { id: "profesion", desc: "Titulo profesional" },
  //   { id: "nombre", desc: "Nombre Postulante" },
  //   { id: "fecha_solicitud", desc: "Fecha solicitud" },
  // ];

  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [showModalStars, setShowModalStars] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [download, setDownload] = useState(null);
  const [downloadEdit, setDownloadEdit] = useState(null);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre Postulante",
  });
  const [view, setView] = useState("");
  const [rating, setRating] = useState(0);

  const dispatch = useDispatch();
  const history = useHistory();

  const schema = Yup.object().shape({
    profesion: Yup.string().required("**Campo requerido"),
    nombre_postulante: Yup.string()
      .matches(
        /^[a-zA-ZÀ-ÿ]+(\s*[a-zA-ZÀ-ÿ]*)*[a-zA-ZÀ-ÿ]+$/,
        "Solo se permiten letras"
      )
      .required("**Campo requerido"),
    estado: Yup.string().required("**Campo requerido"),
    archivo_cv: Yup.string().when("edit", {
      is: () =>
        edit === false || (edit === true && editItem.archivo_cv === null),
      then: Yup.string().required("**Campo requerido"),
    }),
  });

  const schemaStars = Yup.object().shape({
    calificacion: Yup.number().notRequired(),
    descripcion_calificacion: Yup.string()
      .ensure()
      .required("**Campo requerido"),
  });

  const userRoles = useSelector((store) => store.auth.userRoles);

  const {
    loading,
    saveLoading,
    requestTrackingsLength,
    requestTrackings,
    requestTrackingError,
    formError,
  } = useSelector((store) => store.requestTracking);
  const pages = Math.ceil(requestTrackingsLength / limit);

  const { requirementsMonitor, loadingById, requirementsMonitorError } =
    useSelector((store) => store.requirementsMonitor);

  const { estados, loaderEstados, estadosFalla } = useSelector(
    (store) => store.estados
  );

  const { Formations } = useSelector((store) => store.funcFormation);
  const loadingFormation = useSelector((store) => store.funcFormation.loader);

  const { titlesLength, titles, titleError } = useSelector(
    (store) => store.titles
  );

  const loadingTitles = useSelector((store) => store.titles.loading);

  const columns = [
    {
      Header: "División:",
      // accessor: "list_division[0].list_departamento[0].descripcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.plaza
            ? value.row.original.list_plaza[0].list_departamento[0].descripcion
            : ""}
        </div>
      ),
    },
    {
      Header: "Posición:",
      // accessor: "list_puesto[0].descripcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.plaza
            ? value.row.original.list_plaza[0].list_puesto[0].descripcion
            : ""}
        </div>
      ),
    },
    {
      Header: "Título profesional:",
      // accessor: "list_puesto[0].descripcion",
      Filter: "",
      Cell: (value) => (
        <div>
          {value.row.original.profesion
            ? value.row.original.list_preparacion[0].titulo
            : ""}
        </div>
      ),
    },
    {
      Header: "Nombre del postulante:",
      Filter: "",
      Cell: (value) => (
        <div
          className="d-flex justify-content-between"
          style={{
            minWidth: "110px",
          }}
        >
          <p>
            {value.row.original.nombre_postulante
              ? value.row.original.nombre_postulante
              : ""}
          </p>
        </div>
      ),
    },
    {
      Header: "Fecha solicitud:",
      // accessor: "fecha_solicitud",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      Header: "Estado:",
      // accessor: "list_estado[0].nombre_estado",
      Filter: "",
      Cell: (value) => (
        <div
          className="p-2 rounded-pill text-white text-center"
          style={{
            backgroundColor: value.row.original.estado
              ? value.row.original.list_estado[0].color_mostrar
              : "#ffff",
            minWidth: "110px",
          }}
        >
          {value.row.original.estado
            ? value.row.original.list_estado[0].nombre_estado
            : ""}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          {/* <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Editar requisición</Tooltip>}
          > */}
          {
            // userRoles.length > 0 &&
            //   (userRoles.includes("administrador") ||
            //     userRoles.includes("Responsable_Seleccion_Contratacion"))
            view === "administrador" ||
            view === "Responsable_Seleccion_Contratacion" ? (
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Editar postulante</Tooltip>}
              >
                <Button
                  size="sm"
                  variant="link"
                  type="button"
                  onClick={() => onEdit(value.row.original, value.row.index)}
                >
                  {value.row.original.list_estado[0].nombre_estado.toLowerCase() ===
                    "cerrado" ||
                  // (userRoles.length > 0 &&
                  //   !(
                  //     userRoles.includes("administrador") ||
                  //     userRoles.includes("Responsable_Seleccion_Contratacion")
                  //   ))
                  !(
                    view === "administrador" ||
                    view === "Responsable_Seleccion_Contratacion"
                  ) ||
                  (requirementsMonitor &&
                    requirementsMonitor.estado &&
                    requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                      "cerrado") ? (
                    <i className="material-icons">visibility</i>
                  ) : (
                    <i className="material-icons">edit</i>
                  )}
                </Button>
              </OverlayTrigger>
            ) : null
          }
          {/* {userRoles.length > 0 && userRoles.includes("administrador") && (
            <Button
              size="sm"
              className="text-danger"
              variant="link"
              type="button"
              onClick={() => onDelete(value.row.original.id, value.row.index)}
            >
              <i className="material-icons">close</i>
            </Button>
          )} */}
          {/* {userRoles.length > 0 &&
            (userRoles.includes("administrador") ||
              userRoles.includes("jefe")) && ( */}
          <OverlayTrigger
            placement="auto"
            overlay={<Tooltip {...props}>Calificación</Tooltip>}
          >
            <Button
              size="sm"
              variant="link"
              className="text-warning"
              type="button"
              onClick={() =>
                onEditCalification(value.row.original, value.row.index)
              }
            >
              <i className="material-icons">star</i>
            </Button>
          </OverlayTrigger>
          {/* )} */}
          {value.row.original.archivo_cv !== "" && (
            <OverlayTrigger
              placement="auto"
              overlay={<Tooltip {...props}>Descargar cv</Tooltip>}
            >
              <Button
                size="sm"
                className="text-secondary"
                variant="link"
                type="button"
                disabled={
                  download !== null &&
                  parseInt(download) === parseInt(value.row.index)
                }
                onClick={() => {
                  setDownload(parseInt(value.row.index));
                  setTimeout(() => {
                    var element = document.createElement("a");
                    element.setAttribute(
                      "href",
                      // "data:text/plain;charset=utf-8," +
                      //   encodeURIComponent(
                      `${process.env.REACT_APP_URL}/media/${value.row.original.archivo_cv}`
                      // )
                    );
                    element.setAttribute(
                      "download",
                      `${value.row.original.nombre_archivo_cv}`
                    );
                    element.style.display = "none";
                    document.body.appendChild(element);
                    element.click();
                    document.body.removeChild(element);
                    setDownload(null);
                  }, 500);
                }}
              >
                {download !== null &&
                parseInt(download) === parseInt(value.row.index) ? (
                  <Spinner animation="border" size="sm" />
                ) : (
                  <i className="material-icons">plagiarism</i>
                )}
              </Button>
            </OverlayTrigger>
          )}
          {
            // userRoles.length > 0 &&
            //   (userRoles.includes("administrador") ||
            //     userRoles.includes("Responsable_Seleccion_Contratacion"))
            view === "administrador" ||
            view === "Responsable_Seleccion_Contratacion" ? (
              <OverlayTrigger
                placement="auto"
                overlay={<Tooltip {...props}>Enviar postulante</Tooltip>}
              >
                <Button
                  size="sm"
                  className="text-info"
                  variant="link"
                  type="button"
                  onClick={() =>
                    dispatch(sendMailForCandidates(value.row.original))
                  }
                >
                  <i className="material-icons">send</i>
                </Button>
              </OverlayTrigger>
            ) : null
          }
        </div>
      ),
    },
  ];

  // Métodos
  const _getRequestTracking = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getRequestTracking({
        offset: offs,
        limit: lim,
        tipo_busqueda: "plaza_id",
        filter: parseInt(props.match.params.idSolicitud),
        tipo_busqueda_2: tipoBusqueda.id,
        filter_2: filt,
      })
    );

  useEffect(() => {
    _getRequestTracking();
    dispatch(getFuncFormations({}, parseInt(2)));
    dispatch(getEstados({}));
    dispatch(
      getRequirementsMonitorById(parseInt(props.match.params.idSolicitud))
    );
    dispatch(getTitles({}));
  }, []);

  useEffect(() => {
    if (
      props.match.params.rol &&
      config.roles.find((rol) => rol.abrev === props.match.params.rol)
    ) {
      setView(
        config.roles.find((rol) => rol.abrev === props.match.params.rol).rol
      );
    } else {
      setView("");
    }
  }, [props.match.params.rol]);

  const onAdd = () => {
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onEditCalification = (item, index) => {
    if (item.calificacion) {
      setRating(item.calificacion * 20);
    } else {
      setRating(0);
    }
    setIndex(index);
    setEditItem(item);
    setShowModalStars(true);
    setValidated(false);
  };

  const handleRating = (rate, setFieldValue) => {
    if (rating === 20) {
      setRating(0);
      setFieldValue("calificacion", 0);
    } else {
      setRating(rate);
      setFieldValue("calificacion", (rate / 100) * 5);
    }
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getRequestTracking(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = async (req) => {
    const _req = new FormData();
    _req.append("profesion", parseInt(req.profesion));
    _req.append("nombre_postulante", req.nombre_postulante);
    _req.append("estado", parseInt(req.estado));
    _req.append("plaza", parseInt(props.match.params.idSolicitud));
    if (edit && document.getElementById("archivo_cv").files.length > 0) {
      _req.append("archivo_cv", document.getElementById("archivo_cv").files[0]);
      console.log(document.getElementById("archivo_cv").files[0]);
      _req.append(
        "nombre_archivo_cv",
        document.getElementById("archivo_cv").files[0].name
      );
    } else if (
      !edit &&
      document.getElementById("archivo_cv").files.length > 0
    ) {
      _req.append("archivo_cv", document.getElementById("archivo_cv").files[0]);
      console.log(document.getElementById("archivo_cv").files[0]);
      _req.append(
        "nombre_archivo_cv",
        document.getElementById("archivo_cv").files[0].name
      );
    }

    if (!edit) {
      dispatch(saveRequestTracking(_req, setShowModal));
    } else {
      dispatch(editRequestTracking(_req, editItem, index, setShowModal));
    }
  };

  const onSubmitCalification = async (req) => {
    dispatch(editRequestTracking(req, editItem, index, setShowModalStars));
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getRequestTracking(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteRequestTracking(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="mb-4 px-2">
            <div className="d-flex flex-wrap justify-content-start align-items-center">
              <Button
                onClick={() =>
                  history.push(
                    `/seleccion-contratacion/monitor-de-requerimientos/${props.match.params.type}/${props.match.params.id}/${props.match.params.nombrePuesto}/${props.match.params.codigoPuesto}/${props.match.params.rol}`
                  )
                }
                variant="link"
                className="font-weight-bold mr-4 text-dark"
              >
                <i className="material-icons">arrow_back</i>
              </Button>
              <Breadcrumb className="pb-0">
                <Breadcrumb.Item
                  title
                  onClick={() =>
                    history.push(
                      `/seleccion-contratacion/${props.match.params.type}`
                    )
                  }
                >
                  Puestos
                </Breadcrumb.Item>
                <Breadcrumb.Item
                  title
                  onClick={() =>
                    history.push(
                      `/seleccion-contratacion/monitor-de-requerimientos/${props.match.params.type}/${props.match.params.id}/${props.match.params.nombrePuesto}/${props.match.params.codigoPuesto}/${props.match.params.rol}`
                    )
                  }
                >
                  Seguimiento de solicitudes
                </Breadcrumb.Item>
                <Breadcrumb.Item active title>
                  Postulantes
                </Breadcrumb.Item>
              </Breadcrumb>
            </div>
            <hr />
          </div>
          <div className="my-1 pl-md-4 pr-md-3 px-2 d-flex flex-wrap justify-content-between align-items-center">
            <Row className="justify-content-end align-items-center flex-nowrap">
              <h6 className="font-weight-bold text-uppercase">
                {props.match.params.nombrePuesto.replaceAll("-", "/")}
              </h6>
              {loadingById ? (
                <Col size="sm">
                  <div className="d-flex justify-content-center">
                    <Spinner
                      size="sm"
                      animation="border"
                      role="status"
                      className="d-flex justify-content-center"
                    />
                  </div>
                </Col>
              ) : (
                <>
                  {requirementsMonitor &&
                    requirementsMonitor.estado &&
                    // userRoles.length > 0 &&
                    (view === "administrador" ||
                      view === "Responsable_Seleccion_Contratacion") && (
                      // (userRoles.includes("administrador") ||
                      //   userRoles.includes(
                      //     "Responsable_Seleccion_Contratacion"
                      //   ))
                      <Col size="sm">
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Tooltip {...props}>
                              {requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado" && userRoles.includes("administrador")
                                ? "Abrir la requisición"
                                : "Cerrar la requisición"}
                            </Tooltip>
                          }
                        >
                          <Button
                            onClick={() => {
                              if (window.confirm(messages.cancelRequest)) {
                                let _estatus = null;
                                if (
                                  requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                                    "cerrado" &&
                                  userRoles.includes("administrador")
                                ) {
                                  _estatus = estados.data.find(
                                    (_est) =>
                                      _est.nombre_estado.toLowerCase() ===
                                      "abierto"
                                  );
                                } else {
                                  _estatus = estados.data.find(
                                    (_est) =>
                                      _est.nombre_estado.toLowerCase() ===
                                      "cerrado"
                                  );
                                }
                                dispatch(
                                  editRequirementsMonitorById(
                                    // estados.data.find(
                                    //   (_est) =>
                                    //     _est.nombre_estado.toLowerCase() ===
                                    //     "cerrado"
                                    // ),
                                    _estatus,
                                    parseInt(props.match.params.idSolicitud),
                                    requirementsMonitor.estado
                                  )
                                );
                                window.alert(
                                  "Se cerró esta solicitud de plaza"
                                );
                              }
                            }}
                            disabled={
                              (requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado" ||
                                props.match.params.type ===
                                  "plazas-no-vacantes") &&
                              !userRoles.includes("administrador")
                            }
                            className={`p-1 border-0 ${
                              requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                              "cerrado"
                                ? "btn-cerrar"
                                : "text-white"
                            } rounded-pill text-center`}
                            style={{
                              backgroundColor:
                                requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                                "cerrado"
                                  ? ""
                                  : requirementsMonitor.list_estado[0]
                                      .color_mostrar,
                              minWidth:
                                requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                                "cerrado"
                                  ? ""
                                  : "90px",
                            }}
                          >
                            {requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                            "cerrado"
                              ? "cerrado"
                              : "cerrar"}
                          </Button>
                        </OverlayTrigger>
                      </Col>
                    )}
                </>
              )}
            </Row>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                {/* <Col>
                  <h6>
                    <b>Busqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col> */}
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle mr-1"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={<Tooltip {...props}>Ir a Pyxoom</Tooltip>}
                    >
                      <a
                        size="sm"
                        variant="light"
                        className="btn btn-light text-dark rounded-circle py-1 px-2 mr-1"
                        href="https://pyxoomgf.farinter.com/Helper/Home/Login?ReturnUrl=%2fHelper%2fProcess"
                        target="_blank"
                      >
                        <i className="material-icons">shortcut</i>
                      </a>
                    </OverlayTrigger>
                    {
                      // userRoles.length > 0 &&
                      // (userRoles.includes("administrador") ||
                      //   userRoles.includes(
                      //     "Responsable_Seleccion_Contratacion"
                      //   ))
                      (view === "administrador" ||
                        view === "Responsable_Seleccion_Contratacion") &&
                      requirementsMonitor &&
                      requirementsMonitor.estado &&
                      requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                        "cerrado" &&
                      props.match.params.type === "plazas-vacantes" ? (
                        <OverlayTrigger
                          placement="auto"
                          overlay={
                            <Tooltip {...props}>Agregar postulante</Tooltip>
                          }
                        >
                          <Button
                            variant="light"
                            size="sm"
                            className="rounded-circle mr-1"
                            onClick={() => {
                              if (
                                requirementsMonitor &&
                                requirementsMonitor.estado &&
                                requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                                  "cerrado"
                              ) {
                                onAdd();
                              }
                            }}
                            disabled={
                              (requirementsMonitor &&
                                requirementsMonitor.estado &&
                                requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                                  "cerrado") ||
                              props.match.params.type === "plazas-no-vacantes"
                            }
                          >
                            <i className="material-icons">add</i>
                          </Button>
                        </OverlayTrigger>
                      ) : null
                    }
                    {/* <Dropdown className="ml-1 mr-1">
                      <Dropdown.Toggle
                        variant="light"
                        className="btn-sm font rounded-pill"
                      >
                        <i className="material-icons">filter_list</i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        {filters.map((item) => (
                          <Dropdown.Item
                            onClick={() => setTipoBusqueda(item)}
                            key={item.id}
                          >
                            {item.desc}
                          </Dropdown.Item>
                        ))}
                      </Dropdown.Menu>
                    </Dropdown> */}
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading || loadingById ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            requestTrackingsLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable columns={columns} data={requestTrackings} />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={requestTrackingsLength}
                  pages={pages}
                  pagFunc={_getRequestTracking}
                />
              </>
            )
          )}
          {!loading &&
            requestTrackingsLength === 0 &&
            requestTrackingError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!requestTrackingError && (
            <Alert variant="danger" className="mt-4 mb-1">
              {requestTrackingError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Formik
          validationSchema={schema}
          onSubmit={onSubmit}
          initialValues={{
            profesion: edit ? editItem.profesion : "",
            nombre_postulante: edit ? editItem.nombre_postulante : "",
            estado: edit
              ? editItem.estado
              : estados
              ? estados.data[0].id.toString()
              : "",
            archivo_cv: "",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            setFieldValue,
            handleBlur,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="text-muted">
                  {edit
                    ? editItem.list_estado[0].nombre_estado.toLowerCase() ===
                        "cerrado" ||
                      requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                        "cerrado"
                      ? "Postulante"
                      : "Editar postulante"
                    : "Agregar postulante"}
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="my-1">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Profesión
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loadingTitles ? "10" : "12"}>
                        <Form.Control
                          disabled={
                            (titles && titles.length === 0) ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                              "cerrado" ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                          as="select"
                          id="profesion"
                          name="profesion"
                          className="col rounded-pill"
                          onBlur={handleBlur("profesion")}
                          value={values.profesion}
                          onChange={handleChange}
                          isValid={touched.profesion && !errors.profesion}
                          isInvalid={touched.profesion && !!errors.profesion}
                        >
                          <option key="" value="" selected disabled>
                            Seleccione una profesión
                          </option>
                          {titles.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.titulo}
                            </option>
                          ))}
                        </Form.Control>
                      </Col>
                      {loadingTitles && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.profesion && errors.profesion && (
                      <Col>
                        <small className="text-danger">
                          {errors.profesion}
                        </small>
                      </Col>
                    )}
                    {!loadingTitles && titles && titles.length === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron Profesiones
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row} className="mb-md-0">
                  <Form.Label column sm={3}>
                    Nombre del postulante
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.Control
                          id="nombre_postulante"
                          name="nombre_postulante"
                          className="rounded-pill"
                          required
                          type="text"
                          // disabled={edit && parseInt(editItem.tipo_estado) === 1}
                          value={values.nombre_postulante}
                          placeholder=""
                          onBlur={handleBlur("nombre_postulante")}
                          onChange={(e) => handleChange(e)}
                          isInvalid={
                            touched.nombre_postulante &&
                            !!errors.nombre_postulante
                          }
                          disabled={
                            requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                              "cerrado" ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                        ></Form.Control>
                      </Col>
                    </Row>
                    {touched.nombre_postulante && errors.nombre_postulante && (
                      <Col>
                        <small className="text-danger">
                          {errors.nombre_postulante}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Estado
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col sm={loaderEstados ? "10" : "12"}>
                        <Form.Control
                          disabled={
                            loaderEstados ||
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            // (
                            // userRoles.length > 0 &&
                            // !(
                            //   userRoles.includes("administrador") ||
                            //   userRoles.includes(
                            //     "Responsable_Seleccion_Contratacion"
                            //   )
                            // ))
                            !(
                              view === "administrador" ||
                              view === "Responsable_Seleccion_Contratacion"
                            ) ||
                            requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                              "cerrado" ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                          as="select"
                          id="estado"
                          name="estado"
                          className="col rounded-pill"
                          onBlur={handleBlur("estado")}
                          value={values.estado}
                          onChange={handleChange}
                          isValid={touched.estado && !errors.estado}
                          isInvalid={touched.estado && !!errors.estado}
                        >
                          {estados &&
                            estados.data
                              .filter((x) => x.tipo_estado === 2)
                              .map((item) => (
                                <option key={item.id} value={item.id}>
                                  {item.nombre_estado}
                                </option>
                              ))}
                        </Form.Control>
                      </Col>
                      {loaderEstados && (
                        <Col sm={1}>
                          <Spinner animation="border" size="sm" />
                        </Col>
                      )}
                    </Row>
                    {touched.estado && errors.estado && (
                      <Col>
                        <small className="text-danger">{errors.estado}</small>
                      </Col>
                    )}
                    {!!estadosFalla && (
                      <Col>
                        <small className="text-danger">**{estadosFalla}</small>
                      </Col>
                    )}
                    {!loaderEstados && estados && estados.count === 0 && (
                      <Col>
                        <small className="text-danger">
                          **No se encontraron paises
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Hoja de vida
                  </Form.Label>
                  <Col sm={9}>
                    <Row>
                      <Col>
                        <Form.File
                          id="archivo_cv"
                          name="archivo_cv"
                          className="col position-relative my-2"
                          disabled={
                            (edit &&
                              editItem.list_estado[0].nombre_estado.toLowerCase() ===
                                "cerrado") ||
                            requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                              "cerrado" ||
                            props.match.params.type === "plazas-no-vacantes"
                          }
                          value={values.archivo_cv}
                          onChange={handleChange}
                          onBlur={handleBlur("archivo_cv")}
                          isValid={touched.archivo_cv && !errors.archivo_cv}
                          isInvalid={touched.archivo_cv && !!errors.archivo_cv}
                        />
                      </Col>
                    </Row>
                    {touched.archivo_cv && errors.archivo_cv && (
                      <Col>
                        <small className="text-danger">
                          {errors.archivo_cv}
                        </small>
                      </Col>
                    )}
                  </Col>
                </Form.Group>
                {edit && editItem.archivo_cv !== "" && (
                  <>
                    <Row>
                      <Col sm={3}>
                        <p className="text-muted">Documento actual</p>
                      </Col>
                      <Col sm={9}>
                        <Row>
                          <Col>
                            <ul className="list-unstyled">
                              <li
                                key={editItem.id}
                                className="d-flex align-items-center"
                              >
                                <Button
                                  size="sm"
                                  className="mx-3 text-info"
                                  variant="link"
                                  type="button"
                                  onClick={() => {
                                    setDownloadEdit(parseInt(index));
                                    setTimeout(() => {
                                      var element = document.createElement("a");
                                      element.setAttribute(
                                        "href",
                                        // "data:text/plain;charset=utf-8," +
                                        //   encodeURIComponent(
                                        `${process.env.REACT_APP_URL}/media/${editItem.archivo_cv}`
                                        // )
                                      );
                                      element.setAttribute(
                                        "download",
                                        `${editItem.nombre_archivo_cv}`
                                      );
                                      element.style.display = "none";
                                      document.body.appendChild(element);
                                      element.click();
                                      document.body.removeChild(element);
                                      setDownloadEdit(null);
                                    }, 500);
                                  }}
                                >
                                  {downloadEdit !== null &&
                                  parseInt(downloadEdit) === parseInt(index) ? (
                                    <Spinner animation="border" size="sm" />
                                  ) : (
                                    editItem.nombre_archivo_cv
                                  )}
                                </Button>
                              </li>
                            </ul>
                          </Col>
                        </Row>
                      </Col>
                    </Row>
                  </>
                )}
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cerrar
                </Button>
                {edit &&
                  editItem.list_estado[0].nombre_estado.toLowerCase() !==
                    "cerrado" &&
                  requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                    "cerrado" && (
                    <Button
                      className="rounded-pill"
                      disabled={saveLoading}
                      variant="primary"
                      type="submit"
                    >
                      {saveLoading && (
                        <Spinner
                          className="mr-2"
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                        />
                      )}
                      Guardar
                    </Button>
                  )}
                {!edit && (
                  <Button
                    className="rounded-pill"
                    disabled={saveLoading}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoading && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                )}
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Modal para editar calificación */}
      <Modal show={showModalStars} onHide={() => setShowModalStars(false)}>
        <Formik
          validationSchema={schemaStars}
          onSubmit={onSubmitCalification}
          initialValues={{
            calificacion: editItem.calificacion,
            descripcion_calificacion: editItem.descripcion_calificacion
              ? editItem.descripcion_calificacion
              : "Sin comentario",
          }}
        >
          {({
            handleSubmit,
            handleChange,
            handleBlur,
            setFieldValue,
            values,
            touched,
            isValid,
            errors,
          }) => (
            <Form onSubmit={handleSubmit} noValidate validated={validated}>
              <Modal.Header closeButton>
                <Modal.Title className="ft-modal-title">
                  Calificación
                </Modal.Title>
              </Modal.Header>
              <Modal.Body>
                {!!formError && (
                  <Alert variant="danger" className="my-1">
                    {formError}
                  </Alert>
                )}
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Calificación
                  </Form.Label>
                  <Col sm={9}>
                    <Rating
                      name="calificacion"
                      onClick={(e) => handleRating(e, setFieldValue)}
                      ratingValue={rating}
                      readonly={
                        (edit &&
                          editItem.list_estado[0].nombre_estado.toLowerCase() ===
                            "cerrado") ||
                        // (userRoles.length > 0 &&
                        //   !(
                        //     userRoles.includes("administrador") ||
                        //     userRoles.includes("alta_direccion") ||
                        //     userRoles.includes("jefe")
                        //   ))
                        !(
                          view === "administrador" ||
                          view === "alta_direccion" ||
                          view === "jefe"
                        ) ||
                        requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                          "cerrado"
                      }
                      allowHover={
                        !(
                          (edit &&
                            editItem.list_estado[0].nombre_estado.toLowerCase() ===
                              "cerrado") ||
                          // (userRoles.length > 0 &&
                          //   !(
                          //     userRoles.includes("administrador") ||
                          //     userRoles.includes("alta_direccion") ||
                          //     userRoles.includes("jefe")
                          //   ))
                          !(
                            view === "administrador" ||
                            view === "alta_direccion" ||
                            view === "jefe"
                          ) ||
                          requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                            "cerrado"
                        )
                      }
                      // disableFillHover={true}
                      // allowHalfIcon={true}
                      // disableFillHover={true}
                    />
                  </Col>
                </Form.Group>
                <Form.Group as={Row}>
                  <Form.Label column sm={3}>
                    Comentario
                  </Form.Label>
                  <Col sm={9}>
                    <Form.Control
                      id="descripcion_calificacion"
                      name="descripcion_calificacion"
                      className="rounded"
                      as="textarea"
                      value={values.descripcion_calificacion}
                      placeholder="Sin comentario"
                      onChange={(e) => handleChange(e)}
                      onBlur={handleBlur("descripcion_calificacion")}
                      isValid={
                        touched.descripcion_calificacion &&
                        !errors.descripcion_calificacion
                      }
                      isInvalid={
                        touched.descripcion_calificacion &&
                        !!errors.descripcion_calificacion
                      }
                      disabled={
                        (edit &&
                          editItem.list_estado[0].nombre_estado.toLowerCase() ===
                            "cerrado") ||
                        // (userRoles.length > 0 &&
                        // !(
                        //   userRoles.includes("administrador") ||
                        //   userRoles.includes("alta_direccion") ||
                        //   userRoles.includes("jefe")
                        // ))
                        !(
                          view === "administrador" ||
                          view === "alta_direccion" ||
                          view === "jefe"
                        ) ||
                        requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() ===
                          "cerrado" ||
                        props.match.params.type === "plazas-no-vacantes"
                      }
                    ></Form.Control>
                    {touched.descripcion_calificacion &&
                      errors.descripcion_calificacion && (
                        <Col>
                          <small className="text-danger">
                            {errors.descripcion_calificacion}
                          </small>
                        </Col>
                      )}
                  </Col>
                </Form.Group>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  className="rounded-pill"
                  variant="secondary"
                  onClick={() => setShowModalStars(false)}
                >
                  Cerrar
                </Button>
                {
                  // userRoles.length > 0 &&
                  //   (userRoles.includes("administrador") ||
                  //     userRoles.includes("alta_direccion") ||
                  //     userRoles.includes("jefe"))
                  (view === "administrador" ||
                    view === "alta_direccion" ||
                    view === "jefe") &&
                    requirementsMonitor.list_estado[0].nombre_estado.toLowerCase() !==
                      "cerrado" && (
                      <Button
                        className="rounded-pill"
                        disabled={saveLoading}
                        variant="primary"
                        type="submit"
                      >
                        {saveLoading && (
                          <Spinner
                            className="mr-2"
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                          />
                        )}
                        Guardar
                      </Button>
                    )
                }
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>
    </>
  );
};

export default RequestTracking;
